export type profileDetail = "info" | "application" | "contract" | "notpresent" | "safety" | "assets" | "stats" | "notifications" | "chat"

export const profileDetailsArray: profileDetail[] = [
    "info",
    "application",
    "contract",
    "notpresent",
    "safety",
    "assets",
    "stats",
    "notifications",
    "chat"
]

const constants = {
    route: {
        worktimes: 'WorkTimes',
        profiles: 'profiles',
        safeyCourse: 'safetyCourse',
        conversation: 'conversations'
    },
    routeGenerator: {
        toProfile: (id: any) => `/${constants.route.profiles}/${id}`,
        toProfileDetail: (id: any, detail: profileDetail) => `/${constants.route.profiles}/${id}/${detail}` ,
        toConversation: (id: string | number | undefined) => (id != undefined) ? `/${constants.route.conversation}/chat/${id}` : `/${constants.route.conversation}/chat`
    },
    roles: {
        admin: "Admin",
        user:"User",
        profiles: "Profiles",
        contract: "Contract",
        timestamp: "Timestamp",
        worktimes:"Worktimes",
        employee: "Employee",
        revenue: "Revenue",
        jobs: "Jobs",
        conversation: "Conversation",
        asset:"Assets",
        beta: "beta"
    }

}


export { constants }